
import { useEffect, useState } from "react";
import { BigHeading, FlexContainer, LongBlueButton, OverlayActiveStyle, OverlayBaseContainer, OverlayCloseLogo, OverlaySearchEquipmentContainer, SearchEquipmentContainer, SearchingBoxContainer } from "../../assets/style";
import { Box, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import RecordTable, { TableHeader } from "../RecordTable";
import SearchBox from "../SearchBox";
import { RecordModel } from "../../models/RecordModel";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import HookSearchDropDownList from "../HookSearchDropDownList";
import FetchingItems from "../FetchingItems";
import { useLazyGetCompanyDropDownListQuery } from "../../features/comapny/comapnySlice";
import { useLazyGetRoleDropDownListQuery, useLazyGetUserListingQuery } from "../../features/auth/authApiSlice";
import HookSearchInput from "../HookSearchInput";

export const AddUserContainer = ({ label, onSelectRows, selectedRows, role }: any) => {
    const { t, i18n } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);

    const columns: TableHeader[] = [
        { field: 'name', headerName: t('Name'), width: 200, isSortable: true },
        { field: 'email', headerName: t('Email'), width: 200, isSortable: true },
        { field: 'companyName', headerName: t('Company Name'), width: 300, isSortable: true },
        { field: 'roleName', headerName: t('Role Name'), width: 300, isSortable: false },
    ]

    const toggleOverlay = () => {
        setShowOverlay((prevShowOverlay) => !prevShowOverlay);
    };

    return (
        <div>
            {/* Render other components */}
            <Box sx={{ marginLeft: "8px" }}>
                <LongBlueButton onClick={toggleOverlay}>{label ?? t("Add User") + (role? (" Role:" + role) : "")}</LongBlueButton>
            </Box>
            {showOverlay && (
                <SearchUserOverlay
                    showOverlay={showOverlay}
                    toggleOverlay={toggleOverlay}
                    onSelectRows={onSelectRows}
                    selectedRows={selectedRows}
                    role={role}
                    columns={columns}
                />
            )}
            <RecordTable
                columns={columns}
                rows={selectedRows}
                checkbox={false}
                deleteButton={false}
            />
        </div>
    );
};
function SearchUserOverlay({ showOverlay, toggleOverlay, onSelectRows, selectedRows, columns, role }: any) {
    const { t, i18n } = useTranslation();

    const { register, getValues, control, setValue, handleSubmit } = useForm<{ name?: string, email?: string, roleId?: string, companyId?: string, isActive?: boolean }>()

    const [getUserListing] = useLazyGetUserListingQuery()
    const [getRoleDropDownList] = useLazyGetRoleDropDownListQuery()

    const [rows, setRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const fetchDataForPage = async (pageNumber: any, selectedRows: any) => {
        const data = await getUserListing({
            page: pageNumber,
            ...getValues()
        });

        return data.data.records;
    };

    const handleSearchClick = async () => {
        try {
            const data = await fetchDataForPage(1, undefined)
            setData(data)
            setRows(data)
        } catch (error) { }
    };

    useEffect(() => {
        if (role) {
            getRoleDropDownList({}).then(res => {
                if (res.data) {
                    var roles = res.data as any[]
                    setValue("roleId", roles.find(x => x.name == role).id)
                    handleSearchClick()
                }
            })
        }
        else
            handleSearchClick()
    }, [])

    return (
        <OverlayBaseContainer style={showOverlay ? OverlayActiveStyle : {}}>
            <OverlaySearchEquipmentContainer>
                <SearchEquipmentContainer flexGrow={1}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <BigHeading>{t("Search User") + (role? (" Role:" + role) : "") }</BigHeading>
                        <OverlayCloseLogo onClick={toggleOverlay}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </OverlayCloseLogo>
                    </div>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <HookSearchInput title={t("Name")} register={() => register("name")} />
                                <HookSearchInput title={t("Email")} register={() => register("email")} />
                                {!role &&
                                    <FetchingItems<{ id: number, name: string }[]>
                                        useLazyQuery={useLazyGetRoleDropDownListQuery}
                                        render={(items, isLoading) => (
                                            <HookSearchDropDownList
                                                title={t("Role")}
                                                name="roleId"
                                                control={control}
                                                items={isLoading ? [] : items ?? []}
                                                addEmpty={true}
                                            />
                                        )}
                                    />
                                }
                                <FetchingItems<{ id: number, name: string }[]>
                                    useLazyQuery={useLazyGetCompanyDropDownListQuery}
                                    render={(items, isLoading) => (
                                        <HookSearchDropDownList
                                            title={t("Company")}
                                            name="companyId"
                                            control={control}
                                            items={isLoading ? [] : items ?? []}
                                            addEmpty={true}
                                        />
                                    )}
                                />
                                <HookSearchDropDownList
                                    title={t("Is Active")}
                                    name="isActive"
                                    control={control}
                                    items={[{ id: true, name: "True" }, { id: false, name: "False" }]}
                                    addEmpty={true}
                                />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={handleSearchClick}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>

                    <RecordTable
                        columns={columns}
                        rows={rows}
                        checkbox={true}
                        onSelectRows={onSelectRows}
                        selectedRows={selectedRows}
                        pages={data?.totalPages}
                    />
                </SearchEquipmentContainer>
            </OverlaySearchEquipmentContainer>
        </OverlayBaseContainer>
    );
}